<script>
    export let text;
</script>
<span 
	class="tw-text-xl tw-font-serif tw-font-normal">
	{text}
</span>